import axios from "axios";
import router from "@/router";
import i18n from "@/i18n";
const config = require('@/config')

const modules = {
  state: () => ({
    modules: {
      slides: {},
      stories: {}
    },
    modulesLoading: false,
    newSlideAdding: false,
    newStoryAdding: false,
    slideChanging: false,
    storyChanging: false,
  }),
  getters: {
    MODULES_LOADING(state) {return state.modulesLoading},
    SLIDES(state) { return state.modules.slides },
    STORIES(state) { return state.modules.stories },
    NEW_SLIDE_ADDING(state) {return state.newSlideAdding},
    NEW_STORY_ADDING(state) {return state.newStoryAdding},
    SLIDE_CHANGING(state) {return state.slideChanging},
    STORY_CHANGING(state) {return state.storyChanging},
  },
  mutations: {
    setModulesLoading(state, payload) { state.modulesLoading = payload },
    setNewSlideAdding(state, payload) { state.newSlideAdding = payload },
    setNewStoryAdding(state, payload) { state.newStoryAdding = payload },
    setModules(state, payload) { state.modules = payload },
    setSlideChanging(state, payload) { state.slideChanging = payload },
    setStoryChanging(state, payload) { state.storyChanging = payload },
    clearAllModules(state) {
      state.modules.slides = {}
      state.modules.stories = {}
    }
  },
  actions: {
    async getModules({state, commit, dispatch, rootState}, restId) {
      await dispatch('tryAutoSignIn', null, { root: true })
      this.commit('setModulesLoading', true)
      let idToken = rootState.tokens.idToken
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      await axios.get(`${config.servUrl}admin/restaurant-modules/${restId}`, axiosHeader)
        .then(response => {
          this.commit('setModulesLoading', false)
          this.commit('setModules', response.data)
          return true
        })
        .catch(error => {
          this.commit('setModulesLoading', false)
          console.log(error);
          dispatch('addNewNotice', {text: error, error: true})
          return false
        })
    },
    async addImageToModules({state, commit, dispatch, rootState}, payload) {
      // payload = {
        // restId,
        // img,
        // type = 'slide', 'slide_mobile', 'story', 'story_thumb'
      // }
      await dispatch('tryAutoSignIn', null, { root: true })
      let idToken = rootState.tokens.idToken
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'multipart/form-data'}}
      const formData = new FormData();
      formData.append('fileContent', payload.img);
      formData.append('entityType', payload.type);
      formData.append('restaurantId', payload.restId);
      // formData.append('menuItemOptionId', payload.id);
      return axios.post(`${config.servUrl}admin/image-upload`, formData, axiosHeader)
          .then(response => {
            return response.data.paths[0]
          })
          .catch(error => {
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error);
            return false
          })
    },
    async addSlide({state, commit, dispatch, rootState}, payload) {
      await dispatch('tryAutoSignIn', null, { root: true })
      this.commit('setNewSlideAdding', true)
      let idToken = rootState.tokens.idToken
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'application/json'}}
      let data = JSON.stringify({slides: payload.data})
      return axios.put(`${config.servUrl}admin/restaurant-modules/${payload.restId}`, data, axiosHeader)
          .then(response => {
            this.commit('setNewSlideAdding', false)
            dispatch('addNewNotice', {text: i18n.global.t('restModules.alerts.slideAdded')})
            return true
          })
          .catch(error => {
            this.commit('setNewSlideAdding', false)
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error)
            return false
          })
    },
    async changeSlide({state, commit, dispatch, rootState}, payload) {
      await dispatch('tryAutoSignIn', null, { root: true })
      this.commit('setSlideChanging', true)
      let idToken = rootState.tokens.idToken
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'application/json'}}
      let data = JSON.stringify({slides: payload.data})
      return axios.put(`${config.servUrl}admin/restaurant-modules/${payload.restId}`, data, axiosHeader)
          .then(response => {
            commit('setSlideChanging', false)
            dispatch('addNewNotice', {text: i18n.global.t('restModules.alerts.slideChanged')})
            dispatch('getModules', payload.restId)
            return true
          })
          .catch(error => {
            this.commit('setSlideChanging', false)
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error)
            return false
          })
    },
    async addStory({state, commit, dispatch, rootState}, payload) {
      await dispatch('tryAutoSignIn', null, { root: true })
      this.commit('setNewStoryAdding', true)
      let idToken = rootState.tokens.idToken
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'application/json'}}
      let data = JSON.stringify({stories: payload.data})
      return axios.put(`${config.servUrl}admin/restaurant-modules/${payload.restId}`, data, axiosHeader)
          .then(response => {
            this.commit('setNewStoryAdding', false)
            dispatch('addNewNotice', {text: i18n.global.t('restModules.alerts.slideAdded')})
            return true
          })
          .catch(error => {
            this.commit('setNewStoryAdding', false)
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error)
            return false
          })
    },
    async changeStory({state, commit, dispatch, rootState}, payload) {
      await dispatch('tryAutoSignIn', null, { root: true })
      this.commit('setStoryChanging', true)
      let idToken = rootState.tokens.idToken
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'application/json'}}
      let data = JSON.stringify({stories: payload.data})
      return axios.put(`${config.servUrl}admin/restaurant-modules/${payload.restId}`, data, axiosHeader)
          .then(response => {
            commit('setStoryChanging', false)
            dispatch('addNewNotice', {text: i18n.global.t('restModules.alerts.storyChanged')})
            dispatch('getModules', payload.restId)
            return true
          })
          .catch(error => {
            this.commit('setStoryChanging', false)
            dispatch('addNewNotice', {text: error, error: true})
            console.log(error)
            return false
          })
    }
  }
}
export {modules}
